'use client'
import { Button } from '@algoacademy/design-system/web/actions/Button'
import { PlusIcon } from '@heroicons/react/24/solid'

export function AddNewCourseCategoryButton({
  canManageCourseCategories
}: {
  canManageCourseCategories: boolean
}) {
  return (
    canManageCourseCategories && (
      <Button marketing href='/kursy/course-category/upsert' className='w-fit'>
        <PlusIcon />
        Dodaj nową kategorię kursu
      </Button>
    )
  )
}
